// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"05f8c4a7","885":"7a60893d"}[chunkId] + ".chunk.js";
};